import { Component } from '@angular/core';




@Component({
	selector: 'grid-text-editor',
	template: `
    <label *ngIf="showInput" style="margin-bottom:0;" >{{(type=="number" && params.column =="volumeM3COL" || params.column =="milesSavedCOL"  )?(value| number : '2.2-2'): value }}  </label>
    <input  *ngIf="!showInput" #input  [type]="type" [maxlength]="length" min="0" 
	oninput="this.value=this.value.slice(0,this.maxLength)" 
	(keypress)="keyPressAlphaNumeric($event)" (keyup)="keyUpEvent($event)"
	 placeholder={{placeholder}}  [ngStyle]="{'min-width': minwidth}" [(ngModel)]="value"  class="grid-cell-edit-layout " (change)="textUpdated()"
	/>`,
	styles: [`
    input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
  	-webkit-appearance: none;
	  margin: 0;
	}

	.grid-cell-edit-layout{
		margin-left: 2%;
		width: 96%;
		height: 26px;
	
	}`
	],
	standalone: false
})

export class GridTextEditorComponent {
	public params: any;
	showInput = true;
	value: any;
	placeholder: string
	type = "text";
	length = "250";
	minwidth = "50px";
	constructor() { }

	agInit(params: any): void {
		this.params = params;
		const data = params.data;

		// default values
		this.type = 'text';
		this.placeholder = params.placeholder;

		if (params?.isWriteAccess == false) { // NOSONAR
			this.showInput = true;
		}

		switch (params.column) {

			case 'nasuppliercodeCOL':
				this.length = '5';
				this.minwidth = '90px';
				this.value = data.nasuppliercode?.toString().trim();
				data.nasuppliercodeCOL = this;
				this.updateRow(data, 'nasuppliercode');
				break;

			case 'evaluation_commentCOL':
				this.minwidth = '180px';
				this.value = data.evaluation_comment?.toString().trim();
				data.evaluation_commentCOL = this;
				this.updateRow(data, 'evaluation_comment');
				break;

			case 'commentsCOL':
				this.minwidth = '220px';
				this.value = data.comments?.toString().trim();
				data.commentsCOL = this;
				this.updateRow(data, 'comments');
				break;

			case 'volumeM3COL':
				this.minwidth = '30px';
				this.value = typeof data.volumeM3 == 'number' ? data.volumeM3.toFixed(2) : '0.00'; // NOSONAR
				data.volumeM3COL = this;
				this.updateRow(data, 'volumeM3');
				break;

			case 'milesSavedCOL':
				this.minwidth = '30px';
				this.value = typeof data.milesSaved == 'number' ? data.milesSaved.toFixed(2) : '0.00';  // NOSONAR
				data.milesSavedCOL = this;
				this.updateRow(data, 'milesSaved');
				break;
		}

		// edit mode handling
		if (data.checkedEditMode) {
			this.showInput =
				params.column == 'storeAddress' && data.locationId != null; // NOSONAR
		}

		// final override
		if (params?.isWriteAccess == false) { // NOSONAR
			this.showInput = true;
		}
	}

	private updateRow(data: any, field: string): void {
	if (data.rowCheckBox == false) { // NOSONAR
		data[field] = this.value;
		data.isModified = false;
	}
}


	keyPressAlphaNumeric(event) {
		if (this.params.column == 'nasuppliercodeCOL') { // NOSONAR
			const inp = String.fromCharCode(event.keyCode);
			if (/[a-zA-Z0-9]/.test(inp)) {
				return true;
			} else {
				event.preventDefault();
				return false;
			}
		}
		return true;

	}
	keyUpEvent(_event) {
		if (this.params.column == 'volumeM3COL') { // NOSONAR
			

			const text = this.value
			const arr = text.split(".")

			let leftSide, rightSide
			leftSide = arr[0]
			if (arr[0].length > 2) {
				leftSide = arr[0] = arr[0].substring(0, 2)
				this.value = leftSide
			}
			if (arr[1] != undefined) { // NOSONAR
				rightSide = arr[1]
				if (arr[1].length > 1) { rightSide = arr[1] = arr[1].substring(0, 2) }
				this.value = leftSide + "." + rightSide
			}
		} else if (this.params.column == 'milesSavedCOL') { // NOSONAR
			const text = this.value
			const arr = text.split(".")

			let rightSide
			const leftSide = arr[0]
			if (arr[1] != undefined) { // NOSONAR
				rightSide = arr[1]
				if (arr[1].length > 1) { rightSide = arr[1] = arr[1].substring(0, 2) }
				this.value = leftSide + "." + rightSide
			}
		}
	}

	// called when the cell is refreshed
	refresh(params: any): boolean {
		this.params = params;
		return true;
	}


	public textUpdated() {
		let tempVal: any = null
		if (this.params.column == 'nasuppliercodeCOL') { // NOSONAR
			this.params.data.nasuppliercode = this.value
		} else if (this.params.column == 'volumeM3COL') { // NOSONAR
			tempVal = Number(this.value);
			this.params.data.volumeM3 = this.value = tempVal.toFixed(2);
		} else if (this.params.column == 'milesSavedCOL') { // NOSONAR
			tempVal = Number(this.value);
			this.params.data.milesSaved = this.value = tempVal.toFixed(2);
		} else if (this.params.column == 'evaluation_commentCOL') { // NOSONAR
			tempVal = String(this.value);
			this.params.data.evaluation_comment = this.value = tempVal.trim();
		} else if (this.params.column == 'commentsCOL') { // NOSONAR
			tempVal = String(this.value);
			this.params.data.comments = this.value = tempVal.trim();
		}


	}



}
